<template>
  <div class="account_open">
    <div class="open_form app_card">
      <div class="form_title">{{ $t('直接开户') }}</div>
      <div class="form_desc">{{ $t('直接开户内容') }}</div>
      <div class="form">
        <div class="form_item">
          <div class="icon">
            <van-icon name="contact" size="18px" color="#0f172a" />
          </div>
          <van-field v-model="form.userphone" :placeholder="$t('输入账号')" />
        </div>
        <div class="form_item">
          <div class="icon">
            <van-icon name="lock" size="18px" color="#0f172a" />
          </div>
          <van-field v-model="form.userpass" :placeholder="$t('输入密码')" />
        </div>
        <div class="btn" @click="submit">{{ $t('开户') }}</div>
      </div>
    </div>
    <div class="open_list app_card">
      <div class="list_head">
        <div class="muted">{{ $t('直接用户') }}</div>
        <div class="muted_num">{{ $t('用户', { _: total }) }}</div>
      </div>
      <div class="list">
        <List @load="getList" v-model="loading" :finished="!hasMore" :finished-text="$t('Hint.notMore')"
          :loading-text="$t('Hint.loading')">
          <template v-if="list.length">
            <div v-for="(item, index) in list" :key="`item_${index}`" class="item_wrap">
              <div class="list_head">
                <div class="head_name">{{ item.userphone }}</div>
                <div class="head_id">ID {{ item.id }}</div>
              </div>
              <div class="list_check">
                <div class="check_status" :style="item.identitys.includes('disabled') ? { color: '#e84f62' } : {}">
                  {{ item.identitys.includes('disabled') ? $t('未启用') : $t('已启用') }}
                </div>
                <div class="check_time">{{ $format(item.regdate) }}</div>
              </div>
            </div>
          </template>
          <div class="list_not" v-else>
            <img :src="require('@/assets/Img/null/null.png')" alt="">
            <span>{{ $t('目前尚无直接用户') }}</span>
          </div>
        </List>
      </div>
    </div>
  </div>
</template>
<script>
import { Field, Icon, Toast, List } from 'vant';
import { USERS_CHILD_CREATW } from "@/api"
import { post } from "@/utils/newRequest";
export default {
  components: {
    [Field.name]: Field,
    [Icon.name]: Icon,
    Toast,
    List
  },
  data() {
    return {
      form: {
        userphone: '',
        userpass: ''
      },
      list: [],
      page: 0,
      loading: false,
      hasMore: true,
      total: 0
    }
  },
  methods: {
    async submit() {
      if (!this.form.userphone) return Toast(this.$t('输入账号'));
      if (!this.form.userpass) return Toast(this.$t('输入密码'));
      Toast.loading();
      try {
        const res = await USERS_CHILD_CREATW(this.form);
        Toast(res.msg);
        this.form = {
          userphone: '',
          userpass: ''
        }
        setTimeout(() => {
          this.page = 1;
          this.$nextTick(() => {
            this.getList(true);
          })
        }, 500)
      } catch (error) {
        error.msg && Toast(error.msg)
      }
    },
    async getList(lower = false) {
      if (!lower) {
        this.page++;
      }
      this.loading = false
      try {
        const { lists, hasMorePages, total: _total } = await post("/agent/users/lists", {
          pagesize: 20,
          page: this.page,
        });
        this.total = _total;
        const realList = lists;
        this.hasMore = hasMorePages;
        if (lower) {
          this.list = [...realList]
        } else {
          this.list = [...this.list, ...realList];
        }
        this.loading = false;
      } catch (error) {
        // this.loading = false;
        this.loading = true
        this.page--;
      }
    },
  }
}
</script>
<style lang="less" scoped>
.account_open {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 12px;

  .open_form {
    padding: 16px;
    box-shadow: none;

    .form_title {
      color: #0f172a;
      font-size: 16px;
      font-weight: 600;
    }

    .form_desc {
      color: #7a8597;
      font-size: 12px;
      margin-top: 10px;
    }

    .form {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-top: 14px;

      .form_item {
        display: flex;
        align-items: center;
        gap: 2px;
        padding: 10px 16px;
        border-bottom: 1px solid #ebedf0;

        :deep(.van-cell) {
          background-color: transparent;
          padding: 0;

        }
      }

      .btn {
        margin-top: 12px;
        background: linear-gradient(90deg, #8ff5d1, #31e2a5);
        color: #064b38;
        box-shadow: 0 9px 20px #31e2a547;
        font-weight: 600;
        font-size: 14px;
        height: 44px;
        width: 100%;
        border-radius: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .open_list {
    padding: 16px;
    box-shadow: none;

    .list_head {
      .muted {
        color: #7a8597;
        font-size: 16px;
      }

      .muted_num {
        color: #0f172a;
        margin-top: 6px;
        font-weight: 600;
        font-size: 18px;
      }
    }

    .list {
      margin-top: 12px;

      :deep(.van-list) {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }

      .item_wrap {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 12px;
        border-radius: 16px;
        background: #0f172a0a;

        .list_head {
          display: flex;
          flex-direction: column;
          gap: 10px;

          .head_name {
            font-size: 16px;
            color: #0f172a;
            font-weight: 600;
          }

          .head_id {
            font-size: 12px;
            color: #7a8597;
          }
        }

        .list_check {
          display: flex;
          flex-direction: column;
          gap: 10px;

          .check_status {
            width: fit-content;
            color: #31e2a5;
            padding: 6px 12px;
            border: 1px solid #1fe1a53d;
            background: #1fe1a514;
            font-size: 12px;
            border-radius: 100px;
          }

          .check_time {
            font-size: 12px;
            color: #7a8597;
          }
        }

      }
    }

    .list_not {
      padding: 32px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      img {
        width: 160px;
        height: 160px;
        display: block;
      }

      span {
        color: #7a8597;
        font-size: 14px;
        padding: 16px 0 14px;
      }
    }
  }
}
</style>